<template>
  <div class="container-fluid course-card-css">
    <div v-for="(cat,i) in $store.getters.getCategoryStoreData" :key="i">
      <div v-for="(item,j) in $store.getters.getAllCOs" :key="j">
        <div v-if="isPresent(cat,item.category)">
          <div class="pb-3 row justify-content-end">
            <h6 class="col-md-12 text-left main-title">{{$t('common.labels.Courses_in')}} {{cat}}</h6>
          </div>
          <div class="row">
            <swiper>
              <swiper-slide>
                <div>

                  <div class="card-course">
                    <div class="img-fluid" style="background-image: url('../../static/assets/images/ref3.jpg'); "></div>
                    <div class="card-content">
                      <p class="course-name">{{item.title}}</p>
                      <p class="course-cost">{{$t('common.labels.POINTS')}} {{item.price}}</p>
                      <div>
                        <span class="course-text">{{$t('course.numberOfStudentsEnrolled')}}
                          <strong class="pl-2"> {{item.enrolledCount}} +</strong>
                        </span>
                      </div>



                      <div class="rating-ptag"> {{$t('common.labels.Ratings')}}
                        <span v-if="parseInt(item.rating) == 0">
                          <star-rating :rating="parseInt(item.rating)" :read-only=true v-bind:increment="0.5" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
                        </star-rating>  
                        </span>
                        <span v-else>
                          <star-rating :rating="parseInt(item.rating.toFixed(1))" :read-only=true v-bind:increment="0.5" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
                        </star-rating>
                        </span>        
                      </div>
                      
                      <div class="pt-3"> 
                        <div v-if="presentInWishListStore(item.contentId)">
                          <div class="heart" v-on:click="removeFromWishList(item.contentId)" title="Add to Wishlist" v-bind:class="{ 'is-active' : true}"></div>
                        </div>
                        <div v-else>
                          <div class="heart" v-on:click="addToWishList(item.contentId)" title="Add to Wishlist" v-bind:class="{ 'is-active' : false}"></div>
                        </div>

                        <!-- <div v-if="!cartAdd(item.contentId)">
                          <button @click="addToCart(item.contentId)" class='btn btn-blue-outline mb-2'>ADD TO CART</button>
                        </div> -->
                        <div v-if="inPurchase(item.contentId)">
                          <button class='btn mb-2 btn-blue-outline'>{{$t('course.purchased')}}</button>
                        </div>
                        <div v-else-if="cartAdd(item.contentId)">
                          <button class='btn btn-blue mb-2'>{{$t('course.added')}}</button>
                        </div>
                        <div v-else>
                              <button  @click="addToCart(item.contentId)" class='btn btn-blue-outline mb-2'>ADD TO CART</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>

            </swiper>
            <div :options="swiperOptionCourse">
              <div class="swiper-button-prev swiper-course-prev" slot="button-prev">
                <i class="mdi mdi-chevron-left"></i>
              </div>
              <div class="swiper-button-next swiper-course-next" slot="button-next">
                <i class="mdi mdi-chevron-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import StarRating from 'vue-star-rating'
export default {
  name: 'courseCards',
  components: {
    StarRating
  },
  data () {
    return {
      isActive: false,
      notNextTick: true,
      coList: [],
      loList: [],
      add: '',
      swiperOptionCourse: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-course-next',
        prevButton: '.swiper-course-prev',
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 24,
        paginationClickable: true,
        loop: false
      }
    }
  },
  created () {
    this.loList = this.$store.getters.getCourseEnrolled
    this.loList.forEach(element => {
      if (element.courseType === 'CO') {
        this.coList.push(element.contentId)
      }
    })
    this.$store.commit('setCourseCOEnrolled', this.coList)
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.getIsLoggedIn
    }
  },
  methods: {
    removeFromWishList (itemId) {
      var profileId = this.$store.getters.getProfileDetails.profileId
      this.$store.dispatch('removeWishListFromDb', { profileId, itemId })
    },
    addToWishList (itemId) {
      if (this.isLoggedIn()) {
        var profileId = this.$store.getters.getProfileDetails.profileId
        this.$store.dispatch('insertWishListInDb', { profileId, itemId })
      } else {
        window.MKCLAPI.login()
      }
    },
    presentInWishListStore (itemId) {
      this.wishListData = this.$store.getters.getWishListStoreData
      for (var i = 0; i < this.wishListData.length; i++) {
        if (this.wishListData[i].itemId === itemId) {
          return true
        }
      }
    },
    addToCart (id) {
      if (this.isLoggedIn()) {
        this.isActive = true
        let obj = {
          itemId: id,
          profileId: this.$store.getters.getProfileDetails.profileId,
          cartId: this.$store.getters.getCartData.cartId
        }
        this.$store.dispatch('addCartData', obj)
      } else {
        window.MKCLAPI.login()
      }
    },
    inPurchase (itemId) {
      this.courseData = this.coList
      var result = false
      for (var i = 0; i < this.courseData.length; i++) {
        if (this.courseData[i] === itemId) {
          result = true
        }
      }
      return result
    },
    isPresent (courseCategory, currentItemCategoryList) {
      if (currentItemCategoryList !== null) {
        if (currentItemCategoryList.includes(courseCategory)) {
          return true
        } else {
          return false
        }
      }
    },
    cartAdd (itemId) {
      this.cartData = this.$store.getters.getCartData.items
      for (var j = 0; j < this.cartData.length; j++) {
        if (this.cartData[j].itemId === itemId) {
          return true
        }
      }
    }
  },
  mounted () {
    this.$store.dispatch('fetchAllCOsFromDb')
    this.$store.dispatch('fetchSearchCategory')
  }
}
</script>

<style lang="scss">
@import '../../../static/assets/styles/scss/variables.scss';

.course-card-css {
  .swiper-button-prev {
    margin-left: 20px;
    margin-top: -50px;
    font-size: 25px;
    color: #999;
    background-image: none;
  }
  .swiper-button-next {
    margin-right: 20px;
    margin-top: -50px;
    font-size: 25px;
    color: #999;
    background-image: none;
  }
  .heart {
    z-index: 5;
    position: absolute;
    top: -24px;
    right: -24px;
    width: 100px;
    height: 100px;
    background: url('../../../static/assets/images/heart2.png') no-repeat;
    background-position: 0 0;
    cursor: pointer;
    transition: background-position 1s steps(28);
    transition-duration: 0s;
    &.is-active {
      transition-duration: 1s;
      background-position: -2800px 0;
    }
  }
  .card-course {
    border-radius: 3px;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.18);
    border: none;
    background-color: #fff;
    transition: box-shadow 0.25s;
    margin-bottom: 36px;
    .card-content {
      padding: 10px;
      text-align: center;
      .course-name {
        text-decoration: none;
        font-weight: bold;
        font-size: 13px;
        line-height: 18px;
        padding-top: 5px;
        font-family: $opensans;
      }
      .course-text {
        font-size: 12px;
        color: #666;
      }
      .course-cost {
        font-size:12px;
        font-size: 24px;
        color: #52b3e7;
      }
      .rating-ptag {
        font-size: 12px;
        color: #666;
        .rating-star {
          padding-left: 10px;
        }
      }
    }
    .img-fluid {
      height: 132px;
      background: no-repeat center center / cover;
      border-top-right-radius: 3px;
      border-top-left-radius: 3px;
      position: relative;
      &:before {
        content: '';
        position: absolute;
        top: 0px;
        bottom: 0px;
        background: rgba(255, 255, 255, 0.8);
        height: 50px;
        width: 52px;
        right: 0px;
        border-bottom-left-radius: 4px;
      }
    }
    &:hover {
      cursor: pointer;
      transition: box-shadow 0.45s;
      box-shadow: 0px 15px 25px rgba(0, 0, 0, 0.25);
      .course-name {
        text-decoration: underline;
      }
      .btn-blue-outline {
        background: linear-gradient(to right, #67c8fb 0%, #63bdef 100%);
        color: #fff;
        &:hover {
          background: linear-gradient(to right, #55bef7 0%, #42b1ec 100%);
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/course/allCourseCards.vue?29e235ae